<script>
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import EditIcon from "../../icons/EditIcon.vue";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import {axiosDocuments} from "../../../helpers/axios_requests";
import TextareaEditor from "../../small_components/TextareaEditor.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../../small_components/DefaultButton.vue";
import { FORMAT_ERROR_MESSAGE } from '../../../helpers/validation_error_message';
import {NEW_DOCUMENT} from "../../../helpers/new_objects";
import DocumentComponent from "../../parts/DocumentComponent.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import Switcher from "../../small_components/Switcher.vue";

export default {
  name: 'DocumentView',
  components: {
    Switcher,
    DefaultBox,
    DocumentComponent,
    DefaultButton,
    ValidationObserver,
    DefaultSelect, TextareaEditor, DefaultTitle, EditIcon, BadgeBlock, DefaultInput, RouterLinkTo},
  mixins: [routes_mixin],

  data() {
    return {
      getUserRoleIsAdmin: true,
      new_document: false,
      loading: true,
      document: [],
      categories: [],
      excludedUsers: [],
      users: [],
      selectedCategory: [],
    }
  },

  created() {
    this.loading = false;

    this.fetchDocument(this.get_id())
    this.fetchCategories()
  },

  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.document = data || []
      if (data.category) {
        this.selectedCategory = data.category
      }
    },

    fetchDocument(id) {
      if (!id) {
        this.$set(this, 'document', NEW_DOCUMENT())
        this.$set(this, 'new_document', true)
        return
      }
      this.loading = true
      axiosDocuments.get(id)
          .then(r => {
            this.fillData(r.data.document)
          })
          .finally(() => {
            this.loading = false
          })
    },

    fetchCategories() {
      axiosDocuments.getCategories()
          .then(r => {
            this.categories = r.data.collection;
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      this.loading = true
      axiosDocuments.updateDocument(this.document)
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
      }).catch((r) => {
        console.log(r)
      }).finally(() => {
        this.loading = false
      })
    },

    changeCategory(value) {
      this.document.category_id = value.id
      this.selectedCategory = value
    },

    get_id() {
      return Number(this.$route.params.id)
    },
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('documents.document_info') }}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header"> {{ document.title }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                <form class="row mt-20"
                      @submit.prevent="passes(createUpdate)">
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('documents.title')"
                        v-model="document.title"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <default-select
                        :placeholder="$t('documents.category')"
                        :selected_val="selectedCategory"
                        display_item_api_key="title"
                        :list_outer="categories"
                        @change="changeCategory"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">

                    <template >
                      <document-component
                          :value.sync="document.file"
                          :id="document.id ?? 0">
                      </document-component>
                    </template>

                  </div>
                  <div class="row mt-20 justify-content-end align-items-center">
                    <div class="col-md-2 col-2 mb-10 text-endsticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </div>

                </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>
